import { render, staticRenderFns } from "./FaultRecordChild.vue?vue&type=template&id=fca44154&"
import script from "./FaultRecordChild.vue?vue&type=script&lang=js&"
export * from "./FaultRecordChild.vue?vue&type=script&lang=js&"
import style0 from "./FaultRecordChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports